import LpaChangeStatusForm from './LpaChangeStatusForm';

export default LpaChangeStatusForm;
